<template>
    <div  :class="depth >= 1 ? 'tree-view-child' : 'depth ' + depth">
        
        <div class="menu-item-row" @click="showSublevel()" style="cursor: pointer; padding: 6px 0; font-size: 0.9rem;">
            <div class="d-flex justify-content-between align-items-center" :class="filterCat == id ? 'font-weight-bold' : ''" :style="{ color: filterCat == id ? '#713083' : '#333' }">
                <span :style="indent" @click.stop="updateAndNavigate(id); showChildren = true;" style="flex-grow: 1; transition: color 0.2s;">{{label}}</span>
                <span v-if="nodes && nodes.length > 0" class="text-muted" style="font-size: 0.65rem;">
                    <i :class="showChildren ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                </span>
            </div>
        </div>
        <collapse-transition group tag="div" >
            <menu-item :key="node.id" :id="node.id" v-if="showChildren" 
                v-for="node in nodes" :label="node.nombre" 
                :nodes="node.sublevels" :depth="depth + 1"> 
            </menu-item>
        </collapse-transition>

    </div>
</template>

<script>
    import { mapMutations,mapState } from 'vuex'
    import { CollapseTransition } from 'vue2-transitions'
    export default {
        name: 'menu-item',
        components : {
            CollapseTransition
        },
        props: [
            'label',
            'nodes',
            'depth',
            'id',
        ],
        data() {
            return {
                showChildren: false,
            }
        },
        watch:  {
            filterCat() {
                if(!this.nodes && this.id == this.filterCat){
                        this.$store.commit('showSearch')
                }else if(this.$store.state.searchVisible  && this.nodes){
                        this.$store.commit('hideSearch')
                }
            }
        },
        computed: {
            ...mapState(['filterCat']),
            indent() {
                return {
                    transform: `translate(${this.depth * 20}px)`
                }
            },
           
        },
        methods: {
            showSublevel() {
                this.showChildren = !this.showChildren
            },
            updateAndNavigate(id) {
                this.$store.dispatch('getProductosCat', id)
                this.$router.push('/tienda/'+id).catch(()=>{})
            }
        },
    }
</script>

<style>
</style>